$(document).ready(() => {
  if ($('html').hasClass('page-cadence_reviews'))
    yotpoInterval = setInterval(handleYotpoAfterLoad, yotpoIntervalTimeout)

  function handleYotpoAfterLoad() {
    if (!window.yotpo) return;
    if(!$('#yotpo-reviews .main-widget').length) return;
  
    clearInterval(yotpoInterval);
    const mainInner = $('.filters-container')
    const buttonContainer = $('.filters-container-title')
    mainInner.append(`
      <div class="cadence_reviews_filters">
        <div class="cadence_reviews_filters_item" data-value='Leakproof'>
          Leakproof
        </div>
        <div class="cadence_reviews_filters_item" data-value='Durability'>
          Durability
        </div>
        <div class="cadence_reviews_filters_item" data-value='Capacity'>
          Capacity
        </div>
        <div class="cadence_reviews_filters_item" data-value='Magnetic'>
          Magnetic
        </div>
      </div>
    `)
    buttonContainer.append('<a href="#" class="cadence_reviews_button">Write a review</a>')
  }

  $(document).on('click', '.cadence_reviews_filters_item',function() {
    const search = $('.free-text-search-input')
    search.val($(this).attr('data-value'))
    $(".free-text-search-input")[0].dispatchEvent(new KeyboardEvent('keyup',{'keyCode':13, which: 13}))
  })

  $('.press-features_newspaper').on('click', function() {
    $('.press-features_newspaper').removeClass('selected')
    $(this).addClass('selected')
    $('.press-features_image').removeClass('active')
    $(`.${this.id}`).addClass('active')
  })
})
